import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import Downshift from 'downshift'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import MenuItem from '@material-ui/core/MenuItem'
import styles from './styles'
import { withRouter } from 'react-router-dom'
import TextInput from 'components/TextInput'
import ListItem from '@material-ui/core/ListItem'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import ListItemText from '@material-ui/core/ListItemText'
import Avatar from 'react-avatar'
import moment from 'moment'

function renderInput(inputProps) {
  const { InputProps, classes, ref, ...other } = inputProps

  return (
    <div className={classes.search}>
      <TextInput
        inputProps={{
          ...InputProps,
        }}
        {...other}
        fullWidth
      />
    </div>
  )
}

function renderSuggestion({
  suggestion,
  index,
  itemProps,
  highlightedIndex,
  selectedItem,
}) {
  const isHighlighted = highlightedIndex === index

  return (
    <ListItem
      {...itemProps}
      selected={isHighlighted}
      button
      component={Link}
      to={`/clients/${suggestion.id}`}
      key={suggestion.id}
      divider>
      <ListItemAvatar>
        <Avatar
          className="avatar"
          name={suggestion.full_name}
          src={suggestion.avatar}
          size={100}
          color="#D8D8D8"
          fgColor="black"
        />
      </ListItemAvatar>
      <ListItemText
        primary={suggestion.full_name}
        disableTypography
        secondary={
          <div>
            <div>{suggestion.email}</div>
            <div>{moment(suggestion.created_at).format('MM/DD/YY')}</div>
          </div>
        }
      />
    </ListItem>
  )
}

renderSuggestion.propTypes = {
  highlightedIndex: PropTypes.number,
  index: PropTypes.number,
  itemProps: PropTypes.object,
  selectedItem: PropTypes.string,
  suggestion: PropTypes.shape({ label: PropTypes.string }).isRequired,
}

class ClientSearch extends React.Component {
  state = {
    input: '',
  }

  handleInputChange = event => {
    const input = event.target.value
    this.setState({ input }, () => {
      this.props.search(input)
    })
  }

  handleSelect = item => this.props.history.push(`/clients/${item.id}`)

  render() {
    const { classes, clients, isLoading } = this.props
    const { input } = this.state

    return (
      <div>
        <Downshift
          id="downshift-simple"
          inputValue={input}
          itemToString={item => (item ? item.first_name : '')}
          onSelect={this.handleSelect}>
          {({
            getInputProps,
            getItemProps,
            getMenuProps,
            highlightedIndex,
            inputValue,
            isOpen,
            selectedItem,
          }) => (
            <div className={classes.container}>
              {renderInput({
                classes,
                InputProps: getInputProps({
                  onChange: this.handleInputChange,
                  placeholder: 'Search for client...',
                }),
              })}
              <div {...getMenuProps()}>
                {isOpen ? (
                  <Paper className={classes.paper} square>
                    {clients.length ? (
                      clients.map((suggestion, index) =>
                        renderSuggestion({
                          suggestion,
                          index,
                          itemProps: getItemProps({
                            item: suggestion,
                          }),
                          highlightedIndex,
                          selectedItem,
                        }),
                      )
                    ) : (
                      <MenuItem component="div">
                        {isLoading ? 'Loading...' : 'No results'}
                      </MenuItem>
                    )}
                  </Paper>
                ) : null}
              </div>
            </div>
          )}
        </Downshift>
      </div>
    )
  }
}

ClientSearch.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(withRouter(ClientSearch))
